import { Table, Tag } from 'antd';
import React from 'react';
import { dolarMask } from '../../library/helpers/moneyMask';
import moment from 'moment';
import { FormattedMessage, useIntl } from 'react-intl';

function PaymentsTable({ payments }) {
  const intl = useIntl();

  const columns = [
    {
      title: intl.formatMessage({ id: "page.my_account.financial.payments.table.amount" }),
      dataIndex: "amount",
      render: (data) => (
        <span>{dolarMask(data)}</span>
      ),
    },
    {
      title: intl.formatMessage({ id: "page.my_account.financial.payments.table.date" }),
      dataIndex: "created",
      render: (data) => {
        return (
          <span>{moment(data).format("DD/MM/YYYY HH:mm")}</span>
        )
      }
    },
    {
      title: intl.formatMessage({ id: "page.my_account.financial.payments.table.status" }),
      dataIndex: "status",
      render: (data) => {
        if (data === 'I') {
          return (
            <Tag color="geekblue">
              <FormattedMessage id="page.my_account.financial.payments.table.status.processing" />
            </Tag>
          )
        }

        if (data === 'F') {
          return (
            <Tag color="volcano">
              <FormattedMessage id="page.my_account.financial.payments.table.status.fail" />
            </Tag>
          )
        }

        if (data === 'S') {
          return (
            <Tag color="green">
              <FormattedMessage id="page.my_account.financial.payments.table.status.success" />
            </Tag>
          )
        }
      },
    },
    {
      title: intl.formatMessage({ id: "page.my_account.financial.payments.table.receipt" }),
      dataIndex: "receipt_url",
      render: (data, record) => {
        if (record.status === 'S') {
          return (
            <a className='text-primary hover:text-primary' target='_blank' href={data} rel="noreferrer">
              <FormattedMessage id="page.transactions.table.details" />
            </a>
          )
        }
      },
    },
  ];



  return (
    <div className='grid gap-y-5'>
      <Table
        rowKey={"payment_id"}
        pagination={{
          pageSize: 4,
        }}
        dataSource={payments}
        columns={columns}
      />
    </div>
  );
}

export default PaymentsTable;